import { UseMutationOptions, useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { AxiosError } from 'axios';

import { axiosClient } from '@/lib/axios';

export const subscribeToPlan = async ({
  planID,
  code,
}: {
  planID: number;
  code?: string;
}): Promise<{ redirect_url: string }> => {
  const { data } = await axiosClient.put<{ redirect_url: string }>(`/premium/plans/${planID}/subscribe`, { code });
  return data;
};

type UseSubscribeToPlanOptions = {
  config?: Partial<UseMutationOptions<{ redirect_url: string }, AxiosError<{ message: string }>, { planID: number }>>;
  handleAfterFailure: (code?: number) => void;
};

export const useSubscribeToPlan = ({ config, handleAfterFailure }: UseSubscribeToPlanOptions) => {
  const { notification: toaster } = App.useApp();
  return useMutation({
    onError: (error) => {
      toaster.error({
        message: 'Something Went Wrong',
        description: error.response?.data.message,
      });
      handleAfterFailure(error.response?.status);
    },
    ...config,
    mutationFn: subscribeToPlan,
  });
};
